export default __webpack_public_path__ + "static/media/q5_step1.7ead12bf.png";